import React from 'react';

interface IntegrationsZeroStateProps {
  onSetupClick: () => void;
}

const RocketIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09Z" />
    <path d="M12 15l-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2Z" />
    <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0" />
    <path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5" />
  </svg>
);

const ArrowRightIcon: React.FC = () => (
  <svg
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M1 6.5h11M7.5 1.5l5 5-5 5" />
  </svg>
);

export const IntegrationsZeroState: React.FC<IntegrationsZeroStateProps> = ({ onSetupClick }) => {
  return (
    <div className="flex flex-col items-center px-3 py-9 text-center">
      <div className="mb-3.5 flex h-[50px] w-[50px] items-center justify-center rounded-[14px] bg-indigo-100">
        <RocketIcon className="text-indigo-600" />
      </div>
      <p className="mb-2 text-sm font-semibold text-neutral-900">Put your integrations to work</p>
      <p className="mb-4 text-xs leading-relaxed text-neutral-500">
        Create an automation that sends every new lead exactly where it needs to go.
      </p>
      <button
        onClick={onSetupClick}
        className="inline-flex cursor-pointer items-center gap-[7px] rounded-[7px] bg-indigo-600 px-[18px] py-[9px] text-[13px] font-medium text-white transition-colors hover:bg-indigo-700"
      >
        Set up automation
        <ArrowRightIcon />
      </button>
    </div>
  );
};
